<p-sidebar
  [(visible)]="sidebarVisible"
  (onHide)="onSidebarVisibleChange()"
  >
  <div
    id="sidebar"
    class="flex flex-col justify-between border-neutral-200 w-full h-full rounded-lg"
  >
    <div class="overflow-y-auto h-full pb-16">
      <nav class="py-4" id="main-nav">
        <ul>
          <li *ngFor="let item of sidebarItems; trackBy: trackByRoute">
            <a
              [routerLink]="item.isReadyOnProduction ? [item.route] : []"
              [routerLinkActive]="item.isReadyOnProduction ? 'bg-neutral-200 hover:bg-neutral-300' : ''"
              #rla="routerLinkActive"
              [class]="'flex items-center px-4 py-2 justify-between rounded-md ' +
                       (item.isReadyOnProduction ? 'text-neutral-700 hover:bg-neutral-100 cursor-pointer' : 'text-neutral-400 cursor-not-allowed opacity-60')"
              [id]="item.id"
              [attr.aria-disabled]="!item.isReadyOnProduction"
              (click)="sidebarVisible=false;$event.preventDefault()"
              *appHasPermission="item.permission"
              >
              <div class="flex items-center">
                <i [class]="item.icon + ' mr-3 ' + (item.isReadyOnProduction && rla.isActive ? 'text-neutral-600' : item.isReadyOnProduction ? 'text-neutral-500' : 'text-neutral-400')"></i>
                <span>{{ item.labelKey | translate }}</span>
              </div>
              <span
                *ngIf="item.badge"
                [class]="'text-xs px-2 py-0.5 rounded-full ' + (item.isReadyOnProduction ? 'bg-neutral-200 text-neutral-700' : 'bg-neutral-100 text-neutral-400')"
              >{{ item.badge }}</span>
            </a>
          </li>
          <li>
            <a
              class="flex items-center px-4 py-2 justify-between rounded-md text-neutral-700 hover:bg-neutral-100 cursor-pointer"
              id="nav-about"
              (click)="onAbout(); sidebarVisible=false;$event.preventDefault()"
            >
              <div class="flex items-center">
                <i class="pi pi-info-circle mr-3 text-neutral-500"></i>
                <span>{{ 'nav.about' | translate }}</span>
              </div>
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <div>
      <section
        id="sidebar-session-info"
        class="mx-4 mb-2 pt-3 border-t border-neutral-200 flex flex-col gap-1 text-sm"
        [attr.aria-label]="'user_menu.session_info' | translate"
      >
        <div
          class="flex items-center gap-3 px-2 py-1 min-w-0"
          [ngClass]="(isShiftOpen | async) ? 'text-green-700' : 'text-neutral-500'"
          [title]="((isShiftOpen | async) ? 'user_menu.shift_open_badge' : 'user_menu.shift_closed_badge') | translate"
        >
          <span class="w-5 flex justify-center shrink-0">
            <span
              class="inline-block w-2 h-2 rounded-full"
              [ngClass]="(isShiftOpen | async) ? 'bg-green-500' : 'bg-neutral-300'"
            ></span>
          </span>
          <span class="truncate">
            <span id="sidebar-shift-code">
              <ng-container *ngIf="(isShiftOpen | async) && shiftCode; else noShift">
                {{ 'user_menu.shift_code' | translate }} #{{ shiftCode }}
              </ng-container>
              <ng-template #noShift>{{ 'user_menu.no_open_shift' | translate }}</ng-template>
            </span>
            <ng-container *ngIf="(isShiftOpen | async) && (openShiftTime | async) as startTime">
              <span class="opacity-60 mx-1">·</span>
              <span id="sidebar-shift-start" [title]="'user_menu.shift_start_time' | translate">{{ formatShiftStart(startTime) }}</span>
            </ng-container>
          </span>
        </div>
        <div class="flex items-center gap-3 px-2 py-1 min-w-0 text-neutral-700">
          <i class="pi pi-desktop w-5 text-center text-neutral-400 shrink-0"></i>
          <span class="truncate">
            <span class="font-medium" id="sidebar-pos-code" [title]="('user_menu.pos_code' | translate) + ': ' + (posCode || '')">{{ posCode || '--' }}</span>
            <span class="text-neutral-300 mx-1">·</span>
            <span id="sidebar-store-code" [title]="('user_menu.store_code' | translate) + ': ' + (storeCode || '')">{{ storeCode || '--' }}</span>
          </span>
        </div>
        <div class="flex items-center gap-3 px-2 py-1 min-w-0 text-neutral-800">
          <i class="pi pi-user w-5 text-center text-neutral-400 shrink-0"></i>
          <span class="font-medium truncate" id="sidebar-user-name" [title]="userName || ''">{{ userName || '--' }}</span>
        </div>
      </section>
    <div class="relative mx-4 mb-3">
      <button
        type="button"
        id="sidebar-user-card"
        class="w-full flex items-center gap-3 rounded-lg p-2 text-left hover:bg-neutral-100 min-h-[48px]"
        [title]="'user_menu.settings' | translate"
        aria-haspopup="menu"
        (click)="userMenu.toggle($event)"
      >
        <i class="pi pi-cog w-5 text-center text-neutral-500 text-lg shrink-0"></i>
        <span class="flex-1 min-w-0 text-sm font-medium text-neutral-800 truncate">{{ 'user_menu.settings' | translate }}</span>
      </button>
      <p-overlayPanel #userMenu [showCloseIcon]="true" [dismissable]="true" appendTo="body">
        <div class="flex flex-col min-w-[220px] gap-2">
          <div class="px-2 pt-1 pb-2 border-b border-neutral-200">
            <div class="text-xs text-neutral-500 mb-2">{{ 'language.label' | translate }}</div>
            <p-selectButton
              data-testid="pos-language-toggle"
              [options]="languageOptions"
              [(ngModel)]="selectedLanguage"
              optionLabel="label"
              optionValue="value"
              [allowEmpty]="false"
              (onChange)="onLanguageChange($event.value)"
              aria-label="Language"
            ></p-selectButton>
          </div>
          <button
            type="button"
            pButton
            icon="pi pi-lock-open"
            class="p-button-text justify-start"
            (click)="
              userMenu.hide();sidebarVisible=false;onStartShift()
            "
            [disabled]="(isWrongShift | async) || (isShiftOpen | async)"
            *appHasPermission="permissions.OPEN_SHIFT.CREATE"
          >
            <span class="ml-2">{{ 'user_menu.open_shift' | translate }}</span>
          </button>
          <button
            type="button"
            pButton
            icon="pi pi-unlock"
            class="p-button-text justify-start"
            (click)="userMenu.hide();sidebarVisible=false;onCloseShift()"
            [disabled]="!((isWrongShift | async) === false && (isShiftOpen | async))"
            *appHasPermission="permissions.CLOSE_SHIFT.CREATE"
          >
            <span class="ml-2">{{ 'user_menu.close_shift' | translate }}</span>
          </button>
          <ng-container *ngIf="isElectron">
            <button
              type="button"
              pButton
              id="nav-settings"
              icon="pi pi-cog"
              class="p-button-text justify-start"
              (click)="onSettings(); userMenu.hide()"
              *appHasPermission="permissions.SETTINGS.VIEW"
            >
              <span class="ml-2">{{ 'user_menu.settings' | translate }}</span>
            </button>
            <button
              type="button"
              pButton
              id="nav-deactivate"
              icon="pi pi-desktop"
              severity="danger"
              class="p-button-text justify-start"
              (click)="onDeactivate(); userMenu.hide()"
              *appHasPermission="permissions.DEVICE_ACTIVATION.DEACTIVATE"
            >
              <span class="ml-2">{{ 'user_menu.deactivate_device' | translate }}</span>
            </button>
          </ng-container>
          <button
            type="button"
            pButton
            icon="pi pi-sign-out"
            severity="danger"
            class="p-button-text justify-start"
            (click)="onLogout(); userMenu.hide()"
          >
            <span class="ml-2">{{ 'user_menu.logout' | translate }}</span>
          </button>
        </div>
      </p-overlayPanel>
    </div>
    </div>
  </div>
</p-sidebar>

<p-dialog
  [header]="'about.title' | translate"
  [(visible)]="showAboutDialog"
  [modal]="true"
  [style]="{ width: '450px' }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
>
  <div *ngIf="posUiVersion | async as version" class="p-2 flex flex-col gap-5">
    <section>
      <div *ngIf="isElectron" class="font-bold text-lg mb-2">
        {{ 'about.retail_pos' | translate }}
      </div>
      <div class="grid grid-cols-[100px_minmax(0,1fr)] gap-x-4 gap-y-2 text-sm items-baseline">
        <span class="text-neutral-500 text-right">{{ 'common.version' | translate }}:</span>
        <span class="break-words">{{ version }}</span>

        <ng-container *ngIf="isElectron && systemInfo; else webRuntimeDetails">
          <span class="text-neutral-500 text-right">{{ 'about.electron' | translate }}:</span>
          <span class="break-words">{{ systemInfo.electron }}</span>
          <span class="text-neutral-500 text-right">{{ 'about.chromium' | translate }}:</span>
          <span class="break-words">{{ systemInfo.chrome }}</span>
          <span class="text-neutral-500 text-right">{{ 'about.nodejs' | translate }}:</span>
          <span class="break-words">{{ systemInfo.node }}</span>
          <span class="text-neutral-500 text-right">{{ 'about.v8' | translate }}:</span>
          <span class="break-words">{{ systemInfo.v8 }}</span>
          <span class="text-neutral-500 text-right">{{ 'about.os' | translate }}:</span>
          <span class="break-words">{{ systemInfo.os }}</span>
        </ng-container>
        <ng-template #webRuntimeDetails>
          <ng-container *ngIf="!isElectron">
            <span class="text-neutral-500 text-right">{{ 'about.browser' | translate }}:</span>
            <span class="break-words">{{ webRuntimeInfo.browser }}</span>
            <span class="text-neutral-500 text-right">{{ 'about.os' | translate }}:</span>
            <span class="break-words">{{ webRuntimeInfo.os }}</span>
          </ng-container>
        </ng-template>
      </div>
    </section>

    <ng-container *ngIf="isElectron && (electronApplicationVersions | async) as appVersions">
      <section>
        <div class="font-bold text-lg mb-2">{{ 'about.retail_pos_desktop' | translate }}</div>
        <div class="grid grid-cols-[100px_minmax(0,1fr)] gap-x-4 gap-y-2 text-sm items-baseline">
          <span class="text-neutral-500 text-right">{{ 'common.version' | translate }}:</span>
          <span *ngIf="appVersions.desktop.status === 'loaded'; else desktopNotLoaded">{{ appVersions.desktop.version }}</span>
          <ng-template #desktopNotLoaded>
            <span>{{ ((appVersions.desktop.status === 'loading' || appVersions.desktop.status === 'idle') ? 'common.fetching' : 'common.unavailable') | translate }}</span>
          </ng-template>
        </div>
      </section>

      <section>
        <div class="font-bold text-lg mb-2">{{ 'about.pos_middleware' | translate }}</div>
        <div class="grid grid-cols-[100px_minmax(0,1fr)] gap-x-4 gap-y-2 text-sm items-baseline">
          <span class="text-neutral-500 text-right">{{ 'common.version' | translate }}:</span>
          <span *ngIf="appVersions.middleware.status === 'loaded'; else middlewareNotLoaded">{{ appVersions.middleware.version }}</span>
          <ng-template #middlewareNotLoaded>
            <span>{{ ((appVersions.middleware.status === 'loading' || appVersions.middleware.status === 'idle') ? 'common.fetching' : 'common.unavailable') | translate }}</span>
          </ng-template>
        </div>
      </section>
    </ng-container>
  </div>
</p-dialog>
